

import { useEffect, useState } from "react"
import style from "./style.module.css"
import DefaultLoading from "../../../components/DefaultLoading"
import axios from "axios"
import { defaultDateFormatFromISO } from "../../../utils/DefaultDateFormats"
import { Link } from "react-router-dom"
const Results = () => {
    const [isLoading, setIsLoading] = useState(true)
    const [results, setResults] = useState([])


    useEffect(() => {
        axios.get("/getResults")
            .then(res => {
                console.log(res)
                setIsLoading(false)
                setResults(res.data.data)
            })
            .catch(err => {
                console.log(err)
                console.log(err.response)
                setIsLoading(false)
            })
    }, [])
    return (
        <div className={style.mainDiv}>
            <h2 className={style.screenHeading}>Results</h2>
            {
                isLoading
                    ?
                    <DefaultLoading />
                    :
                    <div className={style.resultsWrapper}>
                        {
                            results.map((result, index) => {
                                return (
                                    <Link to={`/result/${result._id}`} key={index} className={style.result}>
                                        <div className={style.resultElement}>
                                            <p className={style.resultElementHeading}>Examinations</p>
                                            <p className={style.resultElementValue}>{result.examination_group_data[0].name}</p>
                                        </div>

                                        <div className={style.resultElement}>
                                            <p className={style.resultElementHeading}>Total Tests</p>
                                            <p className={style.resultElementValue}>{result.exams.length}</p>
                                        </div>
                                        <div className={style.resultElement}>
                                            <p className={style.resultElementHeading}>Declared On</p>
                                            <p className={style.resultElementValue}>{defaultDateFormatFromISO(result.createdAt)}</p>
                                        </div>
                                    </Link>
                                )
                            })
                        }

                    </div>
            }
        </div>
    )
}

export default Results